<template>
	<div class="ReStaffNotificationList">
		
		<h4 class="mb-0 text-primary">Параметры уведомлений <span >{{placeholder}}</span> </h4> 
		<div class="ReStaffNotificationList-wrapper">
			
			<label calss="col-form-label">Выберите типы уведомлений, которые хотите получать, и нажмите кнопку "Сохранить" внизу страницы.</label>
			
			<!-- <div class="d-col mb-3">
				<h4 class="mb-0">Задачи</h4> 
				<base-checkbox v-model="value.task_strarted">Старт задачи</base-checkbox>
				<base-checkbox v-model="value.task_overdue">Задача просрочена</base-checkbox>
				<base-checkbox v-model="value.helpdesk_task_strarted">Старт задачи "Хелпдеск"</base-checkbox>
			</div>
			<div class="d-col mb-3">
				<h4 class="mb-0">Услуги</h4> 
				<base-checkbox v-model="value.srv_new">Новая услуга</base-checkbox>
			</div>
			<div class="d-col mb-3">
				<h4 class="mb-0">Презентации</h4> 
				<base-checkbox v-model="value.pres_seen_by_client">Просмотр презентации клиентом</base-checkbox>
				<base-checkbox v-model="value.pres_obj_liked">Клиенту понравился объект</base-checkbox>
			</div>
			<div class="d-col mb-3">
				<h4 class="mb-0">Другое</h4> 
				<base-checkbox v-model="value.coldcall_getback">Напоминание о необходимости перезвонить из ХЗ</base-checkbox>
				<base-checkbox v-model="value.callcenter_message">Уведомление от контакт-центра</base-checkbox>
				<base-checkbox v-model="value.client_message">Сообщение от клиента</base-checkbox>
				<base-checkbox v-model="value.my_base">Уведобления от "Моя база"</base-checkbox>
				<base-checkbox v-model="value.ads_packets_end">Истекающие рекламные пакеты</base-checkbox>
			</div> -->
			
			


			<!-- <ul class="list-unstyled ">	
				<h6>Из объекта value</h6>
				<li v-for="(item, key) in checkboxes">
				<base-checkbox  v-model="item['value']" :checked="item['value']" >{{ item['label'] }}</base-checkbox>
				</li>
			</ul> -->


			<div class="form-check" v-for="(item,key) in checkboxes" :key="key">
				<label :for="item.key" class="form-check-label">
					<input
						class="form-check-input"
						:value="key"
						:id="key"
						:checked="item['value']" 
						type="checkbox"
						v-model="notifications"
					/>{{item['label']}}
					<span class="form-check-sign"></span>
				</label>
			</div>
		</div>	
	</div>
</template>

<script>
	// import { BaseCheckbox } from 'src/components/index';
	export default {
		name: 'ReStaffNotificationList',
		components: {
			// BaseCheckbox,
		},
		props: {
			value: [Array,String],
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			placeholder: String,
			checkboxes: [Object, Array],
		},
		watch:{
			value(val){
				// this.notifications = this.$GVO.unlinkObject(val);
				this.strObjects  = val;
				// this.getObjecsInString(val);
				this.getObjecsInArray();
				// this.getObjecsInString();
				//console.log('value',val);
			},
			notifications(val){
				this.notifications = val;
				this.getObjecsInString(val);
			},
			strObjects(val){
				this.strObjects = val;
				// this.$emit("change", this.notifications);
				this.$emit("input", this.strObjects);
				// this.getObjecsInArray();
			},


		},
		data () {
			return {
				ver: 1,
				notifications: [],
				strObjects: ''
				// value_data:{
				// 	task_strarted:{value:false, elementType: 'checkbox', value_default: true}, 
				// 	task_overdue:{value:false, elementType: 'checkbox', value_default: true}, 
				// 	helpdesk_task_strarted:{value:false, elementType: 'checkbox', value_default: true}, 
				// 	srv_new:{value:false, elementType: 'checkbox', value_default: true}, 
				// 	pres_seen_by_client:{value:false, elementType: 'checkbox', value_default: true}, 
				// 	pres_obj_liked:{value:false, elementType: 'checkbox', value_default: true}, 
				// 	coldcall_getback:{value:false, elementType: 'checkbox', value_default: true}, 
				// 	// callcenter_message:{value:false, elementType: 'checkbox', value_default: true}, 
				// 	// client_message:{value:false, elementType: 'checkbox', value_default: true}, 
				// },
			}
		},
		computed: {

		},
		methods: {
			getObjecsInString(val){
				this.strObjects = this.notifications.join(',');
				//console.log('this.strObjects',this.strObjects);
				// console.log('this.strObjects',this.strObjects);
			},

			getObjecsInArray() {
				// Борьба с дублями строки
				this.notifications = Array.from(new Set(this.value.split(',')));
			},

		},
		mounted() {
			if(this.value!=''){
				// this.getObjecsInString();
				this.getObjecsInArray();
			}
		}
	}
</script>
<style scoped>
	/* .ReStaffNotificationList{display: flex; flex-wrap: wrap; flex-direction: column;} */
	/* .ReStaffNotificationList-wrapper{display: flex; align-items: baseline; flex-wrap: wrap;}
	.ReStaffNotificationList-wrapper > * {display: inline-block; margin-right: 10px;} */
</style>
